var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 15.9955,
    viewBox: "0 0 32 15.9955",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 0C32 8.8339 24.8365 15.9953 16 15.9953V0H32Z",
    fill: "#508FCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 15.9955C7.16336 15.9955 0 8.83402 0 0.000117478H16V15.9955Z",
    fill: "#86905B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 8.16314C11.4902 8.16314 7.83447 4.50845 7.83447 0H16V8.16314Z",
    fill: "#D6A102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif20);
export default __webpack_public_path__ + "static/media/motif-20.70756832eadda7ada39c7a7942b55c81.svg";
export { ForwardRef as ReactComponent };